var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewZealand = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 30,
    height: 24,
    rx: 4,
    ry: 4,
    fill: "#071b65"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5,13.774v2.226h4v-2.227l3.037,2.227h2.463v-1.241l-3.762-2.759h3.762v-4h-2.74l2.74-2.009v-1.991h-1.441l-4.059,2.977v-2.977H6.5v2.794l-3.257-2.389c-.767,.374-1.389,.983-1.786,1.738l2.532,1.858H1s0,0,0,0v4h3.763l-3.763,2.76v1.24H3.464l3.036-2.226Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.806,5.589l3.285,2.411h1.364L2.36,4.995c-.204,.18-.39,.377-.554,.594Z",
    fill: "#b92831"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92831",
    d: "M1 16L6.454 12 6.454 13 2.363 16 1 16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92831",
    d: "M9.5 16L7.5 16 7.5 11 1 11 1 9 7.5 9 7.5 4 9.5 4 9.5 9 16 9 16 11 9.5 11 9.5 16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92831",
    d: "M16 15.667L11 12 11 13 15.091 16 16 16 16 15.667z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92831",
    d: "M16 4L15.752 4 10.291 8.004 11.655 8.004 16 4.818 16 4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z",
    opacity: 0.15
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z",
    fill: "#fff",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92831",
    d: "M23.495 8.062L23.008 9.56 21.433 9.56 22.707 10.486 22.22 11.984 23.495 11.058 24.769 11.984 24.282 10.486 25.556 9.56 23.981 9.56 23.495 8.062z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.007,12.311l-1.512-1.098-1.512,1.098,.578-1.777-1.512-1.099h1.869l.578-1.777,.578,1.777h1.869l-1.512,1.099,.578,1.777Zm-1.512-1.407l1.037,.752-.396-1.218,1.036-.753h-1.281l-.396-1.219-.396,1.219h-1.281l1.036,.753-.396,1.218,1.037-.752Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92831",
    d: "M23.495 19.076L23.008 20.574 21.433 20.574 22.707 21.5 22.22 22.998 23.495 22.072 24.769 22.998 24.282 21.5 25.556 20.574 23.981 20.574 23.495 19.076z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.007,23.325l-1.512-1.099-1.512,1.099,.578-1.777-1.512-1.099h1.869l.578-1.777,.578,1.777h1.869l-1.512,1.099,.578,1.777Zm-1.512-1.407l1.037,.753-.396-1.219,1.036-.753h-1.281l-.396-1.219-.396,1.219h-1.281l1.036,.753-.396,1.219,1.037-.753Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92831",
    d: "M27.503 12.774L27.111 13.983 25.84 13.983 26.868 14.73 26.475 15.938 27.503 15.191 28.531 15.938 28.139 14.73 29.167 13.983 27.896 13.983 27.503 12.774z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.769,16.265l-1.266-.92-1.266,.92,.483-1.488-1.266-.919h1.564l.483-1.488,.483,1.488h1.564l-1.266,.919,.483,1.488Zm-1.266-1.229l.79,.574-.302-.929,.79-.574h-.977l-.302-.929-.302,.929h-.977l.79,.574-.302,.929,.79-.574Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92831",
    d: "M19.77 13.417L19.377 14.625 18.106 14.625 19.134 15.372 18.742 16.58 19.77 15.833 20.798 16.58 20.405 15.372 21.433 14.625 20.162 14.625 19.77 13.417z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.035,16.907l-1.266-.919-1.266,.919,.483-1.487-1.266-.92h1.564l.483-1.488,.483,1.488h1.565l-1.266,.92,.483,1.487Zm-1.266-1.228l.79,.574-.302-.929,.791-.574h-.977l-.302-.929-.302,.929h-.977l.79,.574-.302,.929,.79-.574Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewZealand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NewZealand.e6350076b9b3195850491f4da48e5c49.svg";